// audio files
import intro_2 from "./intro_2.mp3";
import intro_1 from "./intro_1.mp3";
import presentation_0 from "./presentacion_0.mp3";
import presentation_1 from "./presentacion_1.mp3";
import presentation_2 from "./presentacion_2.mp3";
import presentation_3 from "./presentacion_3.mp3";
import presentation_4 from "./presentacion_4.mp3";
import beautiful from "./a_beautiful_day.mp3";
import world from "./We_Are_The_World.mp3";
import top from "./dbang-world.mp3";
import cinematic from "./cinematic-time-lapse-115672.mp3";
import forest from "./forest-lullaby-110624.mp3";
import podcast from "./the-podcast-intro-111863.mp3";

// audio thumbnails
import lexin from "./lexin.jpeg";
import dbanj from "./dbanj.png";
import jackson from "./jackson.jpeg";
import trinix from "./trinix.jpeg";

export const tracks = [
  {
    title: "Trinix ft Rushawn – Its a beautiful day",
    src: intro_1,
    author: "Trinix ft Rushawn",
  },
  {
    title: "Michael Jackson – We Are The World",
    src: intro_2,
    author: "Michael Jackson",
  },
  {
    title: "D’banj -Top Of The World",
    src: presentation_0,
    author: "Dbanj",
  },
  {
    title: "Cinematic Time Lapse",
    src: presentation_1,
    author: "Lexin Music",
  },
  {
    title: "Forest Lullaby",
    src: presentation_2,
    author: "Lesfm",
  },
  {
    title: "The Podcast Intro",
    src: presentation_3,
    author: "Music Unlimited",
  },
  {
    title: "The Podcast Intro",
    src: presentation_4,
    author: "Music Unlimited",
  },
];
